import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';

class Loading extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.LOADING)
            return null;

        return (
            <div>
                Carregando...
            </div>
        );
    }
}

export default Loading;


// WEBPACK FOOTER //
// src/views/pages/Loading.jsx